<template>
    <div class="horizontal-scroll" :class="[ 'min-size-' + minSize ]">
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default
{
    name: 'horizontal-scroll',

    props: {
        minSize: { type: Number, default: 960 }
    }
}
</script>
<style lang="sass" scoped>
@import "../style/_settings/__index.sass"
@import "../style/_required/_index.sass"

$minSizes: 960px, 640px

.horizontal-scroll
    position: relative

.content
    position: relative

@each $size in $minSizes
    @media screen and (max-width: #{ $size })
        .horizontal-scroll
            overflow-x: auto

        .content
            min-width: #{ $size }

</style>
